module.exports = __webpack_public_path__ + "img/2016.688bd59a.png";